import { render } from "./ArrowBtn.vue?vue&type=template&id=e375a052&scoped=true"
import script from "./ArrowBtn.vue?vue&type=script&lang=js"
export * from "./ArrowBtn.vue?vue&type=script&lang=js"

import "./ArrowBtn.vue?vue&type=style&index=0&id=e375a052&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e375a052"]])

export default __exports__